import { render, staticRenderFns } from "./title_suggestions_item.vue.js?vue&type=template&id=6e2adafa&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./title_suggestions_item.vue?vue&type=template&id=6e2adafa&vue3"
import script from "./title_suggestions_item.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./title_suggestions_item.vue?vue&type=script&lang=js&vue3"
export * from "./title_suggestions_item.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./title_suggestions_item.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports